import React from "react";

import SimplyInsuredLogo from "images/logos/png/simplyinsured--blue.png";

import { LabelSmall } from "Cobalt/BodyText";
import { Footer, FooterAside, FooterNav, FooterLink, FooterTitle } from "Cobalt/Footer";

export const AppFooter = () => (
  <Footer className="pl-16 pr-16 pt-10 pb-10 bg-beige-300">
    <FooterAside>
      <span>
        <a href="/">
          <img
            alt="SimplyInsured"
            style={{
              width: 170,
              borderWidth: 0,
              border: 0,
            }}
            width={170}
            title="SimplyInsured"
            src={SimplyInsuredLogo}
          />
        </a>
      </span>
      <LabelSmall>© {new Date().getFullYear()} Ten 250 Corporation, dba SimplyInsured.</LabelSmall>
      <LabelSmall>Insurance products sold by Vivek Ajay Shah.</LabelSmall>
    </FooterAside>
    <FooterNav>
      <FooterTitle>Company</FooterTitle>
      <FooterLink href="https://get.simplyinsured.com/about-us" className="text-gray-900">
        About Us
      </FooterLink>
      <FooterLink href="https://get.simplyinsured.com/blog" className="text-gray-900">
        Blog
      </FooterLink>
      <FooterLink href="https://get.simplyinsured.com/careers" className="text-gray-900">
        Careers
      </FooterLink>
    </FooterNav>
    <FooterNav>
      <FooterTitle>Help</FooterTitle>
      <FooterLink href="https://support.simplyinsured.com/s/" className="text-gray-900">
        Support
      </FooterLink>
      <FooterLink href="https://get.simplyinsured.com/contact" className="text-gray-900">
        Contact
      </FooterLink>
    </FooterNav>
    <FooterNav>
      <FooterTitle>Legal</FooterTitle>
      <FooterLink href="https://get.simplyinsured.com/insurance-licenses" className="text-gray-900">
        Insurance Licenses
      </FooterLink>
      <FooterLink href="https://get.simplyinsured.com/privacy-policy" className="text-gray-900">
        Privacy Policy
      </FooterLink>
      <FooterLink href="https://get.simplyinsured.com/terms-of-service" className="text-gray-900">
        Terms of Use
      </FooterLink>
    </FooterNav>
  </Footer>
);
